import { getSessionAuthenticationToken } from '../data-access/api/session';

export const generateAuthUrl = async (
	url: string,
	deviceUid: string | undefined,
	userId: string | undefined,
	locale: string,
	isNewUser: string,
	page: string
) => {
	const tokenData = await getSessionAuthenticationToken();

	return `${url}/${page}?token=${tokenData.code}&userId=${userId}&deviceUid=${deviceUid}&locale=${locale}${isNewUser === 'Y' ? '&isNewUser=Y' : ''}`;
};
